import styled from 'styled-components';

import { COLORS } from '../../styles/constants';

export const Container = styled.footer`
  width: 100%;
  height: 9vh;
  bottom: 0;
  padding: 0 25px;
  position: fixed;

  color: ${COLORS.white};

  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;

  background: ${COLORS.darkBackground};

  p {
    margin: 0;
  }

  span {
    color: ${COLORS.tertiary};
  }

  @media only screen and (min-width: 1400px) {
    height: 7vh;
  }

  @media only screen and (max-width: 900px) {
    height: 12vh;
    padding: 18px;
    flex-direction: column;
  }

  @media all and (min-width: 600px) and (max-width: 1200px) {
    /* tablet, landscape iPad, lo-res laptops ands desktops */
    font-size: 26px;
    padding: 0 25px;
    flex-direction: row;
  }

  @media only screen and (max-height: 450px) {
    display: none;
  }
`;

export const FooterLinks = styled.div`
  width: 15vw;

  display: flex;
  flex-direction: row;
  justify-content: space-between;

  a {
    color: ${COLORS.white};
  }

  @media only screen and (max-width: 900px) {
    width: 80%;
    font-size: 16px;
  }

  @media all and (min-width: 600px) and (max-width: 1200px) {
    /* tablet, landscape iPad, lo-res laptops ands desktops */
    font-size: 26px;
    width: 30vw;
  }
`;
